import { connect } from "react-redux";
import { Flex } from "rebass/styled-components";
import React from "react";
import { useToaster } from "@hellocontento/maillard";

import {
  FullCheckbox,
  SettingsTitle,
  SettingsHeader,
  SettingsSection,
  FullCheckboxTitle,
  SettingsDescription,
  FullCheckboxContainer,
  FullCheckboxDescription
} from "./styles";
import Switch from "components/common/form/Switch";
import { openModal } from "state/actions/ModalActions";
import * as accountActions from "state/actions/AccountActions";

const AUTOMATION_MODES = {
  MANUAL: "manual",
  SCHEDULED_BY_DEFAULT: "scheduled_by_default"
};

const AUTOMATION_DESCRIPTION = (
  <>
    Every week Willow Create schedules your next posts automatically and sends
    you an email with the planning.
    <br />
    You can still review, edit, or remove the posts before they are published.
  </>
);

const WillowCreate = ({ account, updateAccount, openModal }) => {
  const addToast = useToaster();

  const scheduledByDefault =
    account.contentFactoryAutomationMode ===
    AUTOMATION_MODES.SCHEDULED_BY_DEFAULT;

  const saveAutomationMode = contentFactoryAutomationMode => {
    updateAccount({ contentFactoryAutomationMode }, undefined, () =>
      addToast("Your Willow Create settings could not be saved.", "error")
    );
  };

  const toggleScheduledByDefault = () => {
    if (scheduledByDefault) {
      saveAutomationMode(AUTOMATION_MODES.MANUAL);
      return;
    }

    openModal("CONFIRMATION_MODAL", {
      title: "Schedule posts automatically?",
      description: AUTOMATION_DESCRIPTION,
      confirmLabel: "Turn on",
      cancelLabel: "Cancel",
      onConfirm: () =>
        saveAutomationMode(AUTOMATION_MODES.SCHEDULED_BY_DEFAULT)
    });
  };

  return (
    <>
      <SettingsHeader>
        <SettingsTitle>Willow Create</SettingsTitle>
        <SettingsDescription>
          Control how Willow Create plans and publishes your weekly content.
        </SettingsDescription>
      </SettingsHeader>

      <SettingsSection>
        <FullCheckboxContainer>
          <Flex flexDirection="column">
            <FullCheckboxTitle>Schedule posts automatically</FullCheckboxTitle>
            <FullCheckboxDescription mt={10}>
              {AUTOMATION_DESCRIPTION}
            </FullCheckboxDescription>
          </Flex>
          <FullCheckbox>
            <Switch
              htmlFor="scheduledByDefault"
              checked={scheduledByDefault}
              onToggle={toggleScheduledByDefault}
            />
          </FullCheckbox>
        </FullCheckboxContainer>
      </SettingsSection>
    </>
  );
};

const mapStateToProps = state => {
  return {
    account: state.account.data
  };
};

export default connect(mapStateToProps, {
  updateAccount: accountActions.updateAccount,
  openModal
})(WillowCreate);
